<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <ul class="tab-header">
                <li
                    class="tab-header-padding"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: false }">
                    <a [routerLink]="['./']">
                        <i class="fa fa-id-badge"></i>
                        Identity Provider
                    </a>
                </li>
                @if (identityProviderExists()) {
                    <li
                        class="tab-header-padding"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: false }"
                        *kno2NetworkFeatureToggle="['SCIM']">
                        <a [routerLink]="['./user-provisioning']">
                            <i class="fa fa-arrow-circle-o-down"></i>
                            User Provisioning
                        </a>
                    </li>
                    <li
                        class="tab-header-padding"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: false }"
                        *kno2NetworkFeatureToggle="['SCIM']">
                        <a [routerLink]="['./user-groups']">
                            <i class="fa fa-group"></i>
                            Group Mapping
                        </a>
                    </li>
                }
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <router-outlet />
        </div>
    </div>
</div>
